import { motion } from "framer-motion";
import { useParams, Link } from "wouter";
import { ArrowLeft, BarChart3 } from "lucide-react";
import { usePoll } from "@/lib/api";
import { PollCard } from "../components/PollCard";
import { Loader } from '@/components/Loader';

export default function PollDetail() {
  const { pollId } = useParams<{ pollId: string }>();
  const { data: pollData, isLoading, error } = usePoll(pollId);

  const poll = pollData?.data;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center pt-16">
        <Loader />
      </div>
    );
  }

  if (error || !poll) {
    return (
      <div className="pt-4 pb-24 md:pt-8 px-4">
        <div className="max-w-4xl mx-auto">
          <Link href="/dashboard" className="btn-ghost mb-6 inline-flex items-center gap-2">
            <ArrowLeft className="w-4 h-4" />
            Back to Dashboard
          </Link>
          <div className="card text-center py-12">
            <BarChart3 className="w-16 h-16 text-dark-muted mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">
              Poll not found
            </h3>
            <p className="text-dark-muted mb-6">
              The poll you're looking for doesn't exist or you don't have access to it.
            </p>
            <Link href="/dashboard" className="btn btn-primary">
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-4 pb-24 md:pt-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Back button */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          className="mb-6"
        >
          <Link href="/dashboard" className="btn-ghost inline-flex items-center gap-2">
            <ArrowLeft className="w-4 h-4" />
            Back to Dashboard
          </Link>
        </motion.div>

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <h1 className="text-3xl md:text-4xl font-bold mb-2">
            {poll.title}
          </h1>
          <p className="text-dark-muted">
            Share your thoughts with the community
          </p>
        </motion.div>

        {/* Poll Card */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          <PollCard poll={poll} />
        </motion.div>
      </div>
    </div>
  );
}

